import {
  type AxiosRequestConfig,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import type { Badge } from './types';
import { apiRoutes } from '@/api/api-routes';

export type BadgeParams = {
  delivery_type: string;
};

export const getBadgeListFn = async (
  params: BadgeParams,
  config?: AxiosRequestConfig
) => {
  const response = await publicHttpClient.get<Badge[]>(
    apiRoutes.master_data.badge,
    {
      params,
      ...config,
    }
  );
  return response.data;
};
